import { app } from '../../tnew';


function removeStartingSlashes(str) {
  if (str === null) {
    return '';
  }

  str = str.toString();

  while (str.length > 0 && str.charAt(0) === '/') {
    str = str.substr(1, str.length - 1);
  }

  return str;
}

class UrlHelper {
  constructor(url) {
    this.url = url || window.location.href;
  }

  getParameterByName(name) {
    name = name.replace(/[\[\]]/g, '\\$&');

    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`, 'i');

    const results = regex.exec(this.url);

    if (!results) {
      return null;
    }

    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }


  updateQueryStringParameter(uri, key, value) {
    const regEx = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';

    if (uri.match(regEx)) {
      return uri.replace(regEx, `$1${key}=${value}$2`);
    }

    return `${uri + separator + key}=${value}`;
  }

  buildAbsolute(relative) {
    let part1 = app.getRootUrl();

    let part2 = relative;

    if (part1 == null || part1.length === 0) {
      return part2;
    }

    if (part2 == null || part2.length === 0) {
      return part1;
    }

    part1 = part1.toString();
    part2 = part2.toString();

    if (part1.length === 0) {
      return part2;
    }

    if (part2.length === 0) {
      return part1;
    }

    if (part1.charAt(part1.length - 1) === '/' && part2.charAt(0) === '/') {
      return part1 + removeStartingSlashes(part2);
    }

    if (part1.charAt(part1.length - 1) !== '/' && part2.charAt(0) !== '/') {
      return `${part1}/${part2}`;
    }

    return part1 + part2;
  }

}


export default UrlHelper;



// WEBPACK FOOTER //
// ./V7/tnew/lib/ajax/UrlHelper.js